import { useRouter } from 'next/router'
import {
  ExamRestoredQuestionsOrderField,
  ExamSubject,
  GqlExamRestoredQuestionsQuery,
  OrderDirection,
  useGqlExamRestoredQuestionsQuery,
} from 'generated/graphql'
import DEFAULT_TEST_ID from '@app.feature/exam/gsat2024-2/constants/defaultTestId'

interface UseGetExamRestoredQuestionsReturnType {
  examRestoredQuestions?: GqlExamRestoredQuestionsQuery['examRestoredQuestions']
}

const useGetExamRestoredQuestions = ({
  defaultTestId,
}): UseGetExamRestoredQuestionsReturnType => {
  const router = useRouter()
  const { query } = router

  const testId =
    query.adminTestId?.toString() ||
    query.testId?.toString() ||
    defaultTestId ||
    DEFAULT_TEST_ID

  const subject = query.subject?.toString() as ExamSubject

  const { data } = useGqlExamRestoredQuestionsQuery({
    variables: {
      filterBy: {
        subject: subject ?? ExamSubject.MATH,
        testId,
        keyword: query.searchKeyword?.toString() ?? '',
        seq: Number(query.seq) || undefined,
      },
      orderBy: {
        direction:
          (query.orderDirection?.toString() as OrderDirection) ??
          OrderDirection.ASC,
        field: ExamRestoredQuestionsOrderField.SEQ,
      },
      pagination: {
        page: query.page ? Number(query.page) : 1,
        pageSize: subject === ExamSubject.MATH ? 21 : 31,
      },
    },
    fetchPolicy: 'network-only',
  })

  return {
    examRestoredQuestions: data?.examRestoredQuestions,
  }
}

export default useGetExamRestoredQuestions
